export default __webpack_public_path__ + "static/media/Columbia-Bold.f6c1c30b.ttf";